<template>
  <div id="footer" class="footer">

  </div>
</template>

<script>
export default {
  name: 'app-footer'
}
</script>



// WEBPACK FOOTER //
// Footer.vue?f5ccfb80